import { useEffect } from 'react';
import { useEpisodeStore } from '@/state/episodeStore';
import { onBroadcast } from '@/services/broadcast';

/**
 * Listens for BroadcastChannel events from other same-browser tabs and applies
 * them to the local episodeStore. Sender side lives in the api wrappers — when
 * a mutation succeeds, it broadcasts to peers.
 */
export function useBroadcastSync() {
  useEffect(() => {
    const off = onBroadcast((event) => {
      const store = useEpisodeStore.getState();
      switch (event.type) {
        case 'scene-updated': {
          const local = store.scenes.find((s) => s.id === event.sceneId);
          if (local && event.version > local.version) {
            // Stale — caller should refetch the scene. For now, mark version
            // forward; full conflict reconciliation lands in Phase 6.
            store.upsertScene({ ...local, version: event.version });
          }
          break;
        }
        case 'scene-deleted': {
          store.removeScene(event.sceneId);
          break;
        }
        case 'image-added': {
          // Other tab created it; we don't have the row yet — flag dirty.
          // Phase 4 wires a refetch hook; for now, just no-op.
          break;
        }
        case 'video-added': {
          break;
        }
      }
    });
    return off;
  }, []);
}
